import { useEffect, useRef } from 'react';
import { useAudioManager } from '../../index';
export function useAudioRef() {
  var audioRef = useRef(new Audio());

  var _useAudioManager = useAudioManager(),
      unregister = _useAudioManager.unregister;

  useEffect(function () {
    var audio = audioRef.current; // Removing the audio from the global audioManager during unmount.

    return function () {
      return unregister(audio);
    };
  }, [unregister]);
  return audioRef;
}